// components/service-worker/ServiceWorkerProvider.tsx
'use client';
import posthog from 'posthog-js';
import { useEffect } from 'react';

export default function ServiceWorkerProvider() {
  useEffect(() => {

    // only init if not in local
    if (process.env.NODE_ENV !== 'development') (
      posthog.init('phc_Ae5U6F8CQpwAJRLIBJoNEeotefdxCWkt0eattP3fRSC',
        {
          api_host: 'https://vtc.heroad.io',
          ui_host: 'https://eu.posthog.com',
          person_profiles: 'always' // or 'always' to create profiles for anonymous users as well
        }
      )
    )
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', async () => {
        try {
          const registration = await navigator.serviceWorker.register('/sw.js');
          console.log('ServiceWorker registration successful:', registration);

          // Écouter les mises à jour
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Nouvelle version disponible
                  console.log('New version available');
                }
              });
            }
          });
        } catch (error) {
          console.error('ServiceWorker registration failed:', error);
        }
      });

      // Gérer les changements de contrôleur
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('New service worker activated');
      });
    }
  }, []);

  return null;
}